<template>
  <div>
		<!-- 子路由出口：订单详情（servicedatails） -->
		<router-view v-if="$route.path.includes('servicedatails')"></router-view>
		<!-- 列表页 -->
		<div v-else>
			   <el-carousel trigger="click">
					 <el-carousel-item v-for="item in 1" :key="item">
					   <img src="@/assets/homeimglist.png" alt="" srcset="" class="bannerlist" />
					 </el-carousel-item>
			   </el-carousel>
			   
			   <div class="sobox">
				   <div class="soso">
					   <div class="soinput">
						   <i class="el-icon-search"></i>
						  <input type="text" placeholder="请输入您要搜索的内容" v-model="keyword"> 
					   </div>
					   <button  @click="chaxun">搜索</button>
				   </div>
			   </div>
			   
			   <div class="xqlist">
				   <div class="liebiao1" v-for="item in list" :key="item" @click="getdatails(item.d_id)">
						<div class="title">
							<h4 class="titleh4">{{item.name}}</h4>
							<span v-if="item.status==-1">已驳回</span>
							<span v-if="item.status==0">审核中</span>
							<span v-if="item.status==1">报价中</span>
							<span v-if="item.status==2">已结束</span>
							
						</div>
						<div class="titleTiem">
							<img src="@/assets/tiem.png" alt="" srcset="" />
							<span>发布时间：{{item.create_time}}</span>
						</div>
						<div class="hylist">
							<div style="display:flex;">
								<div v-for="(i,index) in item.industries" :key="index" >{{i}}</div>
							</div>
						</div>
						<div class="hybox">
							<span>
							    {{item.description}}
							</span>
						</div>
						<div class="hytiem">
		<!-- 					<span>报价剩余时间：23天23时23分</span> -->
							<div style="width:100%;">立即报价 {{item.quotes_count || '0'}}/{{item.quote_num}}</div>
						</div>
				   </div>
			   </div>
			   <div class="fenye" v-if="total>9">
				   <el-pagination
				     background
					 @current-change="handleCurrentChange"
					 :current-page.sync="currentPage1"
					 :page-size="9"
					 layout="total, prev, pager, next ,jumper"
					 :total="total">
				   </el-pagination>
			   </div>
		</div>
  </div>
</template>

<script>
	import {
		DemandIndex,
		banner,
		personal
	} from "@/api/api.js"
	export default {
	  name: 'HelloWorld',
	  data() {
	    return {
		  currentPage1:"",
		  swiperDotIndex:0,
		  current:0,
		  mode: 'round',
		  keyword:"",
		  page:1,
		  list:[],
		  datails:"",
		  token:"",
		  bannerlist:[],
		  info:"",
		  site_title:"",
		  logo:"",
		  total:""
	    }
	  },
	  created() {
	  	this.token=localStorage.getItem('token')
	  	if(this.token){
	  		this.getpersonal()
	  	}
		this.getlist()
	  },
	  methods: {
		getdatails(e){
			const targetPath = '/serviceHome/serviceindex/servicedatails?d_id='+e
			if (this.$route.path !== targetPath) {
				this.$router.push(targetPath)
			}
		},
		handleCurrentChange(e){
			this.page=e
			this.getlist()
		},
		getpersonal(){
			personal({}).then(res=>{
				this.info=res.data.data
			})
		},
		getbanner(){
			banner({}).then(res=>{
				this.bannerlist=res.data.data
			})
		},
		chaxun(){
			this.page=1
			this.getlist()
		},
		getlist(){
			DemandIndex({
				page:this.page,
				status:"",
				keyword:this.keyword,
				limit:"9"
			}).then(res=>{
				console.log(res.data.data.data)
				this.total=res.data.total
				this.list=res.data.data.data
				this.datails=res.data.data
			})
		}
	  },
	}
</script>

<style scoped>
	.bannerlist{
		width:100%;
	}
	.sobox{
		width:100%;
		display:flex;
		justify-content:center;
		align-items:center;
		padding:24px 0px;
	}
	.soso{
		width:792px;
		height:52px;
		background: #FFFFFF;
		border-radius: 12px;
		border: 1px solid #1E3A8A;
		padding:10px 12px;
		box-sizing: border-box;
		display:flex;
		justify-content:space-between;
		align-items:center;
	}
	.soso button{
		width: 60px;
		height: 32px;
		background: #1E3A8A;
		border-radius: 8px 8px 8px 8px;
		font-weight: 500;
		font-size: 14px;
		color: rgba(255,255,255,0.9);
	    border: none;
	}
	.soinput input{
		width:670px;
		border:none;
		outline:none;
		font-weight: 400;
		font-size: 14px;
	}
	.xqlist{
		width:1200px;
		margin: 0 auto;
		display:flex;
/* 		justify-content:space-between; */
		flex-wrap:wrap;
	}
	.xqlist>div:nth-child(3n){
		margin-right:0px;
	}
	.liebiao1{
		width:384px;
		height:203px;
		background: #FFFFFF;
		box-shadow: 0px 4px 4px 0px rgba(0,0,0,0.05);
		border-radius: 12px;
		margin-bottom:24px;
		margin-right:24px;
		padding:12px;
		box-sizing: border-box;
		cursor:pointer;
		transition: all 0.3s;
	}
	.liebiao1:hover{
		transform: scale(1.03);
	}
	.title{
		width:100%;
		display:flex;
		justify-content:space-between;
	}
	.titleh4{
		width:260px;
		overflow: hidden; 
		text-overflow: ellipsis;
		white-space: nowrap;
	}
	.title span{
		color:#1E3A8A;
	}
	.titleTiem{
		width:100%;
		display:flex;
		align-items: center;
	}
	.titleTiem img{
		width:12px;
		height:12px;
		margin-right:5px;
	}
	.titleTiem span{
		font-weight: 400;
		font-size: 12px;
		color: #999999;
	}
	.hylist{
		width:100%;
		overflow: hidden;
		overflow-x: scroll;
		-ms-overflow-style: none; /* IE/Edge 隐藏滚动条 */
		scrollbar-width: none;    /* Firefox 隐藏滚动条 */
	}
	
	.hylist::-webkit-scrollbar {
	      display: none;           /* Chrome/Safari 隐藏滚动条 */
	}
	.hylist div>div{
        padding:3px 5px;
		box-sizing: border-box;
		background: rgba(66,151,255,0.15);
		border-radius: 4px;
		float: left;
		font-weight: 500;
		font-size: 12px;
		color: #4297FF;
		margin-right:6px;
		margin-top:6px;
	}
	.hybox{
		width:100%;
		height:60px;
		margin-top:5px;
		font-weight: 400;
		font-size: 14px;
		color: #666666;
		display: -webkit-box;
		line-clamp: 3;
		-webkit-line-clamp: 3;
		-webkit-box-orient: vertical;
		overflow: hidden;
		text-overflow: ellipsis;
	}
	.hytiem{
		width:100%;
		display:flex;
		justify-content:space-between;
		align-items: center;
		margin-top:12px;
		/* border-radius: 4px 4px 4px 4px;
		padding:5px 8px;
		box-sizing: border-box; */
	}
	.hytiem span{
		font-weight: 500;
		font-size: 12px;
		color: #FF5900;
	}
	.hytiem div{
		width: 174px;
		height: 30px;
		background: #1E3A8A;
		border-radius: 8px;
		display:flex;
		justify-content:center;
		align-items: center;
		font-weight: 500;
		font-size: 14px;
		color: #FFFFFF;
	}
	.fenye{
		width:100%;
		display:flex;
		justify-content:center;
		align-items: center;
		padding-bottom:60px;
	}
	
</style>